import React from 'react';
import { Typography } from '@mui/material';
import { EtilizeProductModel } from '@peerless/data-access/etilize-api-client';
import { RouterLink } from '@/navigation';
import { Link } from './Link';

export type ProductLinkProps = React.PropsWithChildren<
  Pick<EtilizeProductModel, 'mfgPartNumber' | 'title'> & {
    className?: string;
  }
>;

export function ProductLink({ title, mfgPartNumber, className, children }: ProductLinkProps) {
  if (children) {
    return (
      <RouterLink
        style={{ textDecoration: 'none' }}
        className={className}
        href={`/products/${mfgPartNumber}`}
      >
        {children}
      </RouterLink>
    );
  }

  return (
    <Link className={className} color="secondary" href={`/products/${mfgPartNumber}`}>
      <Typography variant="body1">{title}</Typography>
    </Link>
  );
}
